import React, { useEffect, useState } from 'react';
import './login.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../header/header';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LOGO from "../../Assets/images/pngwing.com.png"
// import BGVideo from "../../Assets/images/BGVideo.mp4"
// import BGVideo from "../../Assets/images/background.mp4"
import "../../Pages/Home/home.css"
import ApiService from '../../services/apiService';
import userManagement from '../../services/userManagement';
import { Toast } from 'reactstrap';
import { toast } from 'react-toastify';
import BGVideo from "../../Assets/images/obtimize.avif"
import { ClipLoader } from 'react-spinners';
import { FaArrowLeft } from "react-icons/fa";
const Login = () => {
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: '',
    });

    const [showPassword, setShowPassword] = useState(false);
    const [response, setresponse] = useState();
    const [loader, setLoader] = useState(false);
    const handleRegister = () => {
        navigate('/SignUp');
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleLogin = async () => {
        setLoader(true)
        if (!formData?.emailOrPhone) {
            toast.warning("Enter UserName/Email to Login")
            setLoader(false)
            return;
        } else if (!formData?.password) {
            toast?.warning("Enter Password to Login ")
            setLoader(false)
            return;
        }
        const apiService = new ApiService();
        let body = {
            login: formData.emailOrPhone,
            password: formData.password,
        };
        try {
            const response = await apiService.post('USER_LOGIN', body);
            debugger
            if (response?.status === 200) {
                // const userRole = userManagement.getUserRole(response?.data?.token);
                const user = userManagement.getUserId(response?.data?.token);
                localStorage.setItem('Token', response?.data?.token)
                localStorage.setItem('user', JSON.stringify(user));
                if (user?.Role === "GameUser") {
                    // navigate('/Home');
                    toast.warning("This url is only for Admin side")
                    setLoader(false)
                } else {
                    navigate('/dashboard');
                    // toast.warning("This url is only for Game user")
                    // setLoader(false)
                }
            } else {
                toast.error(response?.data.message)
                setresponse(response?.data.message)
                setLoader(false)
            }

        } catch (error) {
            console.error("Error Login User:", error);
            toast.error(error?.response?.data.message)
            setLoader(false)
        }
    };
    const handleAdminlogin = () => {
        window.history.back();
    };
    return (
        <div className="BGmain">
            <video className="bg-video" autoPlay loop muted playsInline>
                <source src={BGVideo} type="video/mp4" />
            </video>
            <div className="container py-5 mt-5">
                {/* <div className='d-flex justify-content-center'>
                    <button class="btn btn-primary  w-25 mb-3" onClick={handleAdminlogin}><FaArrowLeft />  Back</button>
                </div> */}
                <div className='d-flex justify-content-center'>
                    <div className='blackBox p-3 p-lg-5 mx-lg-5 width-50'>
                        <div className='center'>
                            <img src={LOGO} className='logosize' />
                        </div>
                        <h3 className='text-white center pt-3'>Sign In</h3>
                        <form>
                            <div class="my-3 ">
                                <label for="emailOrPhone" class="form-label" style={{ color: "#fff" }}>Email</label>
                                <input type="text" class="form-control p-2" id="emailOrPhone" aria-describedby="emailHelp"
                                    name="emailOrPhone"
                                    value={formData.emailOrPhone}
                                    onChange={handleChange} />
                            </div>
                            <div class="mb-4">
                                <label for="password" class="form-label start" style={{ color: "#fff" }}>Password</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control p-2"
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                    />
                                    <span className="input-group-text" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>
                            <h6>{response}</h6>
                        </form>
                        <div className='center p-3 '>
                            {loader === true ?
                                <button class="btn btn-scondary center w-100 btn-lg " type="button">
                                    <ClipLoader color='#fff' />
                                </button>
                                :
                                <button class="btn btn-primary" onClick={handleLogin}>Sign In</button>
                            }
                        </div>
                        {/* <div className='smallhead center py-4'>Forget Password ?</div> */}
                        {/* <div className='lowhead center pt-2 gap-3'>Register Account   {"  "} */}
                        {/* <div style={{ color: "#26BBFF", cursor: "pointer" }} onClick={handleRegister}> Here</div></div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
